
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/Navbar';


const services = [
  {
    id: 1,
    title: "Brand Story Package",
    description: "Complete brand storytelling through cinematic video",
    features: [
      "Brand story consultation",
      "4K cinematic filming",
      "Professional editing",
      "Color grading",
      "Sound design",
      "2-3 minute final video",
      "Multiple format delivery"
    ]
  },
  {
    id: 2,
    title: "Product Showcase",
    description: "High-end product videography that sells",
    popular: true,
    features: [
      "Product styling consultation",
      "Studio lighting setup",
      "Multiple angle coverage",
      "Macro detail shots",
      "Motion graphics integration",
      "60-90 second showcase",
      "Social media cuts"
    ]
  },
  {
    id: 3,
    title: "Corporate Event",
    description: "Professional event coverage and highlights",
    features: [
      "Multi-camera setup",
      "Professional audio recording",
      "Live streaming option",
      "Same-day highlights reel",
      "Full event documentation",
      "Drone coverage (if permitted)",
      "Custom graphics package"
    ]
  },
  {
    id: 4,
    title: "Social Media Content",
    description: "Engaging content for all platforms",
    features: [
      "Platform-specific formats",
      "Trending audio integration",
      "Quick turnaround",
      "Batch content creation",
      "Story templates",
      "Reels and TikTok ready",
      "Monthly content packages"
    ]
  }
];

const portfolioProjects = [
  {
    id: 1,
    title: "ACC National Commercial",
    client: "ACC National",
    category: "Brand Story",
    videoId: "qYwzEzuPzek",
    thumbnail: "https://img.youtube.com/vi/qYwzEzuPzek/maxresdefault.jpg",
    description: "A compelling brand story showcasing ACC National's commitment to excellence and innovation in their industry.",
    type: "full"
  },
  {
    id: 2,
    title: "NQ Springs 4x4 X Superior Engineering Upgrade",
    client: "NQ Springs 4x4",
    category: "Commercial Video",
    videoId: "1kHkkheRvNg",
    thumbnail: "https://img.youtube.com/vi/1kHkkheRvNg/maxresdefault.jpg",
    description: "Professional commercial showcasing 4x4 upgrade services and superior engineering quality.",
    type: "full"
  },
  {
    id: 3,
    title: "ACC Event Highlight Video",
    client: "ACC National",
    category: "Event Coverage",
    videoId: "R0tQtq1dpSM",
    thumbnail: "https://img.youtube.com/vi/R0tQtq1dpSM/maxresdefault.jpg",
    description: "Professional event highlight coverage showcasing key moments and energy.",
    type: "full"
  },
  {
    id: 4,
    title: "Drag Racing Promo",
    client: "Commercial Client",
    category: "Promotional Video",
    videoId: "UAFQWsZNm4E",
    thumbnail: "https://img.youtube.com/vi/UAFQWsZNm4E/maxresdefault.jpg",
    description: "High-energy drag racing promotional video featuring vintage hot rod showcase.",
    type: "full"
  },
  {
    id: 6,
    title: "NQ Springs 4x4 Client Review",
    client: "NQ Springs 4x4",
    category: "Client Testimonial",
    videoId: "Q9B2RNXs4vY",
    thumbnail: "https://img.youtube.com/vi/Q9B2RNXs4vY/maxresdefault.jpg",
    description: "Client testimonial showcasing satisfaction with NQ Springs 4x4 services.",
    type: "full"
  }
];

export default function Commercial() {
  const [selectedProject, setSelectedProject] = useState(null);

  const handleProjectClick = (project) => {
    setSelectedProject(project);
  };

  const closeProjectModal = () => {
    setSelectedProject(null);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-gray-50 to-zinc-50">
      {/* Navigation */}
      <Navbar variant="light" position="absolute" />

      {/* Hero Section with Video Banner */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Video Background - Desktop */}
        <div className="absolute inset-0 w-full h-full hidden md:block">
          <iframe
            src="https://www.youtube.com/embed/YIPkAbm9RVQ?autoplay=1&mute=1&loop=1&playlist=YIPkAbm9RVQ&controls=0&showinfo=0&rel=0&iv_load_policy=3&modestbranding=1&playsinline=1&vq=hd1440"
            title="Commercial Video Background"
            className="w-full h-full object-cover"
            style={{ minWidth: '100%', minHeight: '100%', transform: 'scale(1.1)' }}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
          {/* Video Overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70"></div>
        </div>

        {/* Video Background - Mobile (Shorts) */}
        <div className="absolute inset-0 w-full h-full md:hidden">
          <iframe
            src="https://www.youtube.com/embed/6fjQ9yKreGA?autoplay=1&mute=1&loop=1&playlist=6fjQ9yKreGA&controls=0&showinfo=0&rel=0&iv_load_policy=3&modestbranding=1&playsinline=1"
            title="Commercial Mobile Video Background"
            className="w-full h-full object-cover"
            style={{ minWidth: '100%', minHeight: '100%', transform: 'scale(1.1)' }}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
          {/* Video Overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70"></div>
        </div>

        <div className="relative z-10 text-center px-6 max-w-6xl mx-auto text-white">
          <div className="mb-8">
            <span className="inline-block px-8 py-3 bg-white/20 backdrop-blur-sm rounded-full text-white font-semibold text-sm tracking-wider border border-white/30">
              COMMERCIAL VIDEOGRAPHY
            </span>
          </div>
          <h1 className="text-6xl md:text-8xl font-black mb-8 tracking-tight leading-none text-white drop-shadow-2xl">
            ELEVATE YOUR
            <span className="block bg-gradient-to-r from-slate-400 via-gray-400 to-zinc-400 bg-clip-text text-transparent">
              BRAND STORY
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-white/90 max-w-4xl mx-auto leading-relaxed mb-12 font-light drop-shadow-lg">
            Cinematic storytelling that transforms businesses into brands, creating compelling narratives that resonate with your audience
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <button 
              onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
              className="px-10 py-4 bg-gradient-to-r from-slate-600 to-gray-600 text-white font-bold text-lg rounded-full hover:from-slate-700 hover:to-gray-700 transition-all duration-300 transform hover:scale-105 shadow-2xl cursor-pointer whitespace-nowrap backdrop-blur-sm"
            >
              VIEW SERVICES
            </button>
            <button 
              onClick={() => document.getElementById('portfolio')?.scrollIntoView({ behavior: 'smooth' })}
              className="px-10 py-4 bg-white/20 backdrop-blur-sm border-2 border-white/50 text-white font-bold text-lg rounded-full hover:bg-white/30 hover:border-white/70 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-2xl"
            >
              VIEW PORTFOLIO
            </button>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
          <div className="animate-bounce">
            <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
              <div className="w-1 h-3 bg-white/70 rounded-full mt-2 animate-pulse"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Portfolio Section */}
      <section id="portfolio" className="py-32 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-20">
            <span className="inline-block px-8 py-3 bg-slate-100 rounded-full text-slate-700 font-semibold text-sm tracking-wider border border-slate-200 mb-6">
              OUR WORK
            </span>
            <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-8 tracking-tight">
              Commercial Portfolio
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Discover how we've helped businesses across industries tell their stories through compelling video content
            </p>
          </div>

          {/* Portfolio Grid - All Videos */}
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {portfolioProjects.map((project) => (
                <div key={project.id} className="group cursor-pointer">
                  <div 
                    className="relative overflow-hidden rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
                    onClick={() => handleProjectClick(project)}
                    style={{ aspectRatio: '16/9' }}
                  >
                    <img 
                      src={project.thumbnail}
                      alt={project.title}
                      className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                        <h3 className="text-xl font-bold mb-2 leading-tight">{project.title}</h3>
                        <p className="text-slate-200 flex items-center text-base">
                          <i className="ri-building-line mr-2"></i>
                          {project.client}
                        </p>
                      </div>
                    </div>
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="bg-gray-900/90 backdrop-blur-sm rounded-full flex items-center justify-center border border-gray-700/50 shadow-lg w-16 h-16">
                        <i className="ri-play-fill text-white text-2xl ml-1"></i>
                      </div>
                    </div>
                    <div className="absolute top-4 right-4">
                      <div className="bg-black/70 backdrop-blur-sm rounded-full px-3 py-1 text-white text-sm font-medium">
                        {project.category}
                      </div>
                    </div>
                  </div>
                  <div className="mt-4 text-center">
                    <h3 className="text-lg font-semibold text-gray-900 mb-1 leading-tight">{project.title}</h3>
                    <p className="text-gray-600 text-base">{project.client}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="text-center mt-16">
            <Link 
              to="/contact" 
              className="inline-block px-10 py-4 bg-gradient-to-r from-slate-600 to-gray-600 text-white font-bold text-lg rounded-full hover:from-slate-700 hover:to-gray-700 transition-all duration-300 transform hover:scale-105 shadow-lg cursor-pointer whitespace-nowrap"
            >
              DISCUSS YOUR PROJECT
            </Link>
          </div>
        </div>
      </section>

      {/* Project Modal */}
      {selectedProject && (
        <div className="fixed inset-0 bg-black/95 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="relative w-full max-w-6xl mx-auto">
            {/* Close Button - Top Right (Desktop) */}
            <button
              onClick={closeProjectModal}
              className="absolute -top-12 right-0 text-white hover:text-gray-300 cursor-pointer transition-colors z-10 hidden md:block"
            >
              <i className="ri-close-line text-3xl"></i>
            </button>

            {/* Close Button - Inside Modal (Mobile-friendly) */}
            <button
              onClick={closeProjectModal}
              className="absolute top-4 right-4 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white rounded-full p-2 cursor-pointer transition-all z-20"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
            
            <div className="relative bg-black rounded-2xl overflow-hidden shadow-2xl">
              {selectedProject.type === 'short' ? (
                // Vertical video display ONLY for shorts
                <div className="flex justify-center bg-black">
                  <div className="relative" style={{ width: '360px', height: '640px' }}>
                    <iframe
                      src={`https://www.youtube.com/embed/${selectedProject.videoId}?autoplay=1&rel=0&modestbranding=1&vq=hd1440`}
                      title={selectedProject.title}
                      className="w-full h-full border-0"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
              ) : (
                // Horizontal video display for full videos
                <div className="aspect-video">
                  <iframe
                    src={`https://www.youtube.com/embed/${selectedProject.videoId}?autoplay=1&rel=0&modestbranding=1&vq=hd1440`}
                    title={selectedProject.title}
                    className="w-full h-full"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              )}
              
              <div className="p-6 bg-gradient-to-r from-gray-900 to-black text-white">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-2xl font-bold mb-2">{selectedProject.title}</h3>
                    <p className="text-gray-300 flex items-center mb-2">
                      <i className="ri-building-line mr-2"></i>
                      {selectedProject.client}
                    </p>
                    <p className="text-gray-400 text-sm">{selectedProject.description}</p>
                  </div>
                  <div className="text-right">
                    <span className={`inline-block px-4 py-2 rounded-full text-sm font-medium ${
                      selectedProject.type === 'short' 
                        ? 'bg-slate-500 text-white' 
                        : 'bg-gray-700 text-gray-200'
                    }`}>
                      {selectedProject.type === 'short' ? 'Short Video' : selectedProject.category}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Services Section */}
      <section id="services" className="py-32 bg-gradient-to-br from-gray-50 to-slate-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-20">
            <span className="inline-block px-8 py-3 bg-slate-100 rounded-full text-slate-700 font-semibold text-sm tracking-wider border border-slate-200 mb-6">
              OUR SERVICES
            </span>
            <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-8 tracking-tight">
              Commercial Services
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-16">
              Professional videography services tailored to elevate your business and connect with your audience
            </p>
            
            {/* Single Call-to-Action Button */}
            <div className="mt-12">
              <Link
                to="/contact"
                className="inline-block py-6 px-16 bg-gradient-to-r from-slate-600 to-gray-600 text-white rounded-2xl font-bold text-2xl transition-all duration-300 hover:from-slate-700 hover:to-gray-700 shadow-xl hover:shadow-2xl hover:scale-105 cursor-pointer"
              >
                Let's Discuss Your Project & Get a Quote Now
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            {/* Company Info */}
            <div className="md:col-span-1">
              <div className="flex items-center space-x-3 mb-4">
                <img 
                  src="https://images.squarespace-cdn.com/content/v1/6329980709c417765c18ef9c/1663928993488-9PHELX1GHR1MGT4SNOLP/minchio+brothers+logo.png?format=100w" 
                  alt="Minchio Brothers Logo" 
                  className="h-10 w-10"
                />
                <span className="text-gray-900 font-bold text-lg">MINCHIO BROTHERS</span>
              </div>
              <p className="text-gray-600 mb-4 text-sm leading-relaxed">
                Professional videography services across Queensland, specializing in Real Estate, Commercial, and Social Media content.
              </p>
              <div className="flex space-x-3">
                <a href="https://www.instagram.com/minchiobrothers/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center hover:bg-gray-800 transition-colors cursor-pointer">
                  <i className="ri-instagram-fill text-white text-lg"></i>
                </a>
                <a href="mailto:media@matthewminchio.com" className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center hover:bg-gray-800 transition-colors cursor-pointer">
                  <i className="ri-mail-fill text-white text-lg"></i>
                </a>
                <a href="tel:+61431323137" className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center hover:bg-gray-800 transition-colors cursor-pointer">
                  <i className="ri-phone-fill text-white text-lg"></i>
                </a>
              </div>
            </div>

            {/* Services */}
            <div>
              <h3 className="text-gray-900 font-bold mb-4">Services</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/real-estate" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Real Estate Videography</Link></li>
                <li><Link to="/commercial" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Commercial Production</Link></li>
                <li><Link to="/social-media" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Social Media Content</Link></li>
                <li><span className="text-gray-600">Drone Videography</span></li>
                <li><span className="text-gray-600">Event Coverage</span></li>
                <li><span className="text-gray-600">Brand Storytelling</span></li>
              </ul>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-gray-900 font-bold mb-4">Quick Links</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Home</Link></li>
                <li><Link to="/reviews" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Client Reviews</Link></li>
                <li><Link to="/contact" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Contact Us</Link></li>
                <li><Link to="/contact" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Get Quote</Link></li>
                <li><a href="https://www.minchsolutions.au" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Minch Solutions</a></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-gray-900 font-bold mb-4">Contact Info</h3>
              <div className="space-y-3 text-sm">
                <div className="flex items-start space-x-2">
                  <i className="ri-phone-line text-gray-600 mt-0.5"></i>
                  <div>
                    <a href="tel:+61431323137" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer font-medium">+61 431 323 137</a>
                    <p className="text-gray-500 text-xs">Available 9AM - 6PM</p>
                  </div>
                </div>
                <div className="flex items-start space-x-2">
                  <i className="ri-mail-line text-gray-600 mt-0.5"></i>
                  <div>
                    <a href="mailto:media@matthewminchio.com" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer font-medium">media@matthewminchio.com</a>
                    <p className="text-gray-500 text-xs">24hr response time</p>
                  </div>
                </div>
                <div className="flex items-start space-x-2">
                  <i className="ri-map-pin-line text-gray-600 mt-0.5"></i>
                  <div>
                    <p className="text-gray-600 font-medium">Service Areas:</p>
                    <p className="text-gray-500 text-xs">Townsville, Brisbane, Gold Coast</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-200 pt-6 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-500 text-sm mb-4 md:mb-0">© 2021 MINCHIO BROTHERS. ALL RIGHTS RESERVED</p>
            <div className="flex items-center space-x-4 text-sm">
              <a href="https://www.minchsolutions.au" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gray-600 cursor-pointer">
                Made by Minchsolutions
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
